import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { cssTransition, Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
const Zoom = cssTransition({
  collapseDuration: 100,
  enter: "zoomIn",
  exit: "zoomOut",
});
root.render(
  <BrowserRouter>
    <AuthProvider>
      <ToastContainer
        hideProgressBar={true}
        position="top-center"
        autoClose={2000}
        // transition={Slide}
        draggable={false}
        closeButton={
          <img
            style={{
              height: "10px",
              width: "10px",
              position: "absolute",
              right: "2%",
              top: "40%",
            }}
            src={require("./assets/images/close-black.png")}
          />
        }
      />
      <App />
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
